/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Plane = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 30 30" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M10.726 30.002l-3.694-5.276-.843.527-1.445-1.444.527-.843-5.276-3.694.658-.659c.853-.852.994-.847 6.94.637l.312-.498c.99-1.486 2.897-3.916 4.556-5.692L1.687 5.688l.665-.666c1.453-1.453 2.414-1.343 5.235-.78l.071.019 10.714 3.214 3.254-3.038c.794-.795 2.388-2.311 3.922-3.334.677-.452 2.74-1.828 3.958-.611 1.217 1.217-.159 3.28-.61 3.958-1.023 1.534-2.54 3.129-3.355 3.941l-3.018 3.235 3.232 10.785c.564 2.82.673 3.782-.78 5.235l-.665.665-7.372-10.774c-1.775 1.659-4.204 3.564-5.673 4.544l-.518.324c1.485 5.945 1.49 6.088.637 6.94zm-3.265-7.385l2.655 3.792c-.228-1-.58-2.41-1.021-4.176l-.138-.55 1.461-.913c1.585-1.058 4.377-3.274 6.091-4.988l.665-.664 7.292 10.657c.212-.509.124-1.224-.235-3.022l-3.46-11.537 3.648-3.91c3.658-3.657 4.204-5.488 3.983-5.71-.222-.221-2.053.324-5.692 3.965l-3.929 3.666L7.245 5.766c-1.798-.359-2.513-.446-3.022-.234l10.658 7.29-.665.667c-1.715 1.714-3.93 4.506-5 6.11l-.9 1.442-.55-.138c-1.762-.44-3.168-.792-4.172-1.017l3.786 2.65-.134.215z" />
      </g>
    </svg>
  </span>
);

Plane.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Plane.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Plane;
